<template>
  <v-container>
    <h1 class="my-2">Facturas Por Cobrar</h1>
    <v-row class="ma-0">
      <v-col cols="12" md="12" class="d-flex my-2 justify-end py-0 px-0">
        <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
          <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
            <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
          </div>
          <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ "Total currency gain: " }}</div>
          <span style="font-family: 'montserrat-bold'" :style="{ color: '#0075B8' }">
            {{ " $" + formatMoney(totalProfit) + " " + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN') }}
          </span>
        </div>
      </v-col>
      <v-row class="ma-0" style="width: 100%;">
        <v-col class="pa-0 my-4">
          <v-text-field
            v-model="busqueda"
            placeholder="Buscar"
            clearable
            hide-details
            outlined
            style="width: 280px; font-family: 'montserrat-medium'; border-radius: 20px;"
            prepend-inner-icon="mdi-magnify"
          />
        </v-col>
        <v-col style="display: flex; justify-content: flex-end; align-items: center;" class="pa-0 my-4">
          <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-col class="pa-0 mb-4" cols="3">
        <v-autocomplete
          :label="'Selecciona un status'"
          :items="statusList"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          clearable
          class="mr-2"
          color="black"
          item-value="sStatusId"
          item-text="sName"
          @change="getInvoices()"
          v-model="selectedStatus"
        ></v-autocomplete>
      </v-col>
      <v-col class="pa-0 mb-4" cols="3">
        <v-autocomplete
          :label="'Selecciona un cliente'"
          :items="clientRecipients"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          clearable
          color="black"
          class="mr-2"
          item-value="sClientRecipientId"
          item-text="sName"
          @change="getInvoices()"
          v-model="selectedClient"
        ></v-autocomplete>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end; gap: 8px;">
        <v-btn
          color="black"
          elevation="8"
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
          @click="dialogCreateInvoice = true"
          :disabled="loading"
        >
          {{ "Create invoice" }}
        </v-btn>
        <v-btn
          color="black"
          elevation="8"
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
          @click="openCollectDialog()"
          :disabled="selectedInvoices.length === 0 || loading"
        >
          {{ "Collect" + (selectedInvoices.length > 0 ? ' (' + selectedInvoices.length + ')' : '') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table v-else class="d-none d-sm-block" :items-per-page="5" hide-default-header style="background-color: white !important" :items="filteredInvoices">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "" }}</th>
            <th class="header__title center">{{ "Cliente" }}</th>
            <th class="header__title center">{{ "Fecha de compra" }}</th>
            <th class="header__title center">{{ "Fecha de vencimiento" }}</th>
            <th class="header__title center">{{ "Factura" }}</th>
            <th class="header__title center">{{ "Orden de compra" }}</th>
            <th class="header__title center">{{ "Estatus" }}</th>
            <th class="header__title center">{{ "Monto total" }}</th>
            <th class="header__title center">{{ "Tipo de cambio protegido" }}</th>
            <th class="header__title center">{{ "Currency gain" }}</th>
            <th class="header__title center">{{ "Profit (%)" }}</th>
            <th class="header__title right">{{ "Acciones" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.sInvoiceMXId">
            <td class="table__item">
              <v-checkbox
                v-if="item.sStatusId === '8e99628b-317c-4569-b149-9dc0105503a5'"
                :input-value="isInvoiceSelected(item)"
                color="black"
                @change="toggleSelectInvoice(item)"
                hide-details
                class="mt-0 pt-0"
              ></v-checkbox>
            </td>
            <td class="table__item">{{ item.sName || '-' }}</td>
            <td class="table__item">{{ formatDate(item.dPurchaseDate) }}</td>
            <td class="table__item">{{ formatDate(item.dDueDate) }}</td>
            <td class="table__item">{{ item.sInvoice }}</td>
            <td class="table__item">{{ item.sId || '-' }}</td>
            <td class="table__item">
              <v-chip v-if="item.sStatusId == '8e99628b-317c-4569-b149-9dc0105503a5'" class="ma-2" color="black" outlined>
                {{ "To pay" }}
              </v-chip>
              <v-chip v-else-if="item.sStatusId == '9cb23e7a-ca9b-4530-a617-83a894553b60'" class="ma-2" outlined color="black">
                {{ "Paid" }}
              </v-chip>
            </td>
            <td class="table__item">{{ "$ " + formatMoney(item.dTotalAmount) + " USD" }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dRateProtection) + " MXN" }}</td>
            <td class="table__item" :style="item.dCurrencyGain == 0 ? 'color: black;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' ' + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN')) : "-" }}</td>
            <td class="table__item" :style="item.dProfitPercentage == 0 ? 'color: black;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
            <td class="table__item">
              <v-tooltip v-if="item.sStatusId === '8e99628b-317c-4569-b149-9dc0105503a5'" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialogEditInvoice = true, invoice = Object.assign({}, item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip v-if="item.sStatusId === '8e99628b-317c-4569-b149-9dc0105503a5'" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialogDeleteInvoice(item)" v-bind="attrs" v-on="on" icon color="red">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>

    <!-- Dialog Crear Factura -->
    <v-dialog v-if="dialogCreateInvoice" v-model="dialogCreateInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ 'Agregar factura' }}</span>
        </v-card-title>
        <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
          <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ 'Add the following information to add a new invoice.' }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-form ref="formNew" style="width: 100%" lazy-validation v-on:submit.prevent>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Invoice *'" required style="border-radius: 10px" outlined v-model="forms.new.sInvoice" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Purchase Order'" required style="border-radius: 10px" outlined v-model="forms.new.sId" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete :label="'Cliente *'" required style="border-radius: 10px" :items="clientRecipients" outlined item-text="sName" item-value="sClientRecipientId" v-model="forms.new.sClientRecipientId" :rules="[rules.required]" :disabled="loading"></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Fecha de compra *'" required style="border-radius: 10px" outlined type="date" v-model="forms.new.dPurchaseDate" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field :label="'Total amount USD *'" required outlined style="border-radius: 10px" type="number" v-model="forms.new.dTotalAmount" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Dias de credito *'" required outlined style="border-radius: 10px" type="number" v-model="forms.new.iCreditPeriod" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Tipo de cambio protegido *'" required outlined style="border-radius: 10px" type="number" v-model="forms.new.dRateProtection" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
          <small>{{'* indicates required field'}}</small>
        </v-card-text>
        <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
          <v-btn color="black" elevation="8" class="mr-2 px-10" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined :disabled="loading" @click="dialogCreateInvoice = false, resetNewForm()">
            {{ 'Cancelar' }}
          </v-btn>
          <v-btn color="black" elevation="8" class="white--text px-10" style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;" :disabled="loading" :loading="loading" @click="createInvoice()">
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Editar Factura -->
    <v-dialog v-if="dialogEditInvoice" v-model="dialogEditInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ 'Editar factura' }}</span>
        </v-card-title>
        <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
          <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ 'Add the following information to edit the invoice.' }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-form ref="formEdit" style="width: 100%" lazy-validation v-on:submit.prevent>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Invoice *'" required style="border-radius: 10px" outlined v-model="invoice.sInvoice" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Purchase Order'" required style="border-radius: 10px" outlined v-model="invoice.sId" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete :label="'Cliente *'" required style="border-radius: 10px" :items="clientRecipients" outlined item-text="sName" item-value="sClientRecipientId" v-model="invoice.sClientRecipientId" :rules="[rules.required]" :disabled="loading"></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Fecha de compra *'" required style="border-radius: 10px" outlined type="date" v-model="invoice.dPurchaseDate" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field :label="'Total amount USD *'" required outlined style="border-radius: 10px" type="number" v-model="invoice.dTotalAmount" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Dias de credito *'" required outlined style="border-radius: 10px" type="number" v-model="invoice.iCreditPeriod" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field :label="'Tipo de cambio protegido *'" required outlined style="border-radius: 10px" type="number" v-model="invoice.dRateProtection" :rules="[rules.required]" :disabled="loading"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
          <small>{{'* indicates required field'}}</small>
        </v-card-text>
        <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
          <v-btn color="black" elevation="8" class="mr-2 px-10" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined :disabled="loading" @click="dialogEditInvoice = false, invoice = {}">
            {{ 'Cancelar' }}
          </v-btn>
          <v-btn color="black" elevation="8" class="white--text px-10" style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;" :disabled="loading" :loading="loading" @click="updateInvoice()">
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Eliminar Factura -->
    <v-dialog v-if="dialogDelete" v-model="dialogDelete" persistent max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important;">
            {{ "¿Estás seguro de que deseas eliminar esta factura?" }}
          </v-card-title>
          <v-card-text v-if="!loading" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">{{ "Una vez que eliminas la factura no podras recuperarla." }}</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular indeterminate color="red"></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn color="#0075B8" elevation="8" class="mr-2 px-10" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined :disabled="loading" @click="dialogDelete = false">
            {{ "Cancelar" }}
          </v-btn>
          <v-btn color="red" elevation="8" class="white--text px-10" style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;" :disabled="loading" @click="deleteInvoice()">
            {{ "Eliminar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Collect Invoice (Stepper 2 pasos) -->
    <v-dialog v-if="dialogCollect" v-model="dialogCollect" persistent width="fit-content">
      <v-card>
        <v-stepper v-model="collectStep" alt-labels elevation="0">
          <v-stepper-header class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; box-shadow: none;">
            <v-stepper-step :complete="collectStep > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="collectStep > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Tipo de cobro -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ 'Selecciona el tipo de cobro' }}</span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" outlined :class="{ 'selected-card': selectedCollectType === 'balance' }" @click="selectedCollectType = 'balance'" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px; cursor: pointer;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ 'MXN Balance' }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify">{{ 'Convierte tus USD a MXN y deposita en tu wallet MXN' }}</div>
                      </div>
                      <v-icon v-if="selectedCollectType === 'balance'" color="black">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" outlined :class="{ 'selected-card': selectedCollectType === 'account' }" @click="selectedCollectType = 'account'" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px; cursor: pointer;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ companyAccount ? companyAccount.sName : 'Cuenta empresa' }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify">{{ companyAccount && companyAccount.sAccountNumber ? '********' + companyAccount.sAccountNumber.slice(-4) : 'Pago directo a la cuenta bancaria de la empresa' }}</div>
                      </div>
                      <v-icon v-if="selectedCollectType === 'account'" color="black">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn color="black" elevation="8" class="mr-2 px-10" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined @click="cancelCollect()">
                    {{ 'Cancelar' }}
                  </v-btn>
                  <v-btn color="black" elevation="8" class="white--text px-10" style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;" @click="openCollectDetail()" :disabled="selectedCollectType === null">
                    {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <!-- Paso 2: Detalle del cobro -->
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ 'Detalle del cobro' }}</span>
                </v-card-title>
                <v-card-text class="pt-4 pb-0 px-0">
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                      <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ 'Factura' }}</th>
                          <th>{{ 'Cliente' }}</th>
                          <th>{{ 'Monto USD' }}</th>
                          <th>{{ 'Monto MXN' }}</th>
                          <th>{{ 'Tipo de cambio' }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="inv in collectDetail.invoices" :key="inv.sInvoiceMXId">
                          <td>{{ inv.sInvoice }}</td>
                          <td>{{ inv.sName }}</td>
                          <td>${{ formatMoney(inv.dOriginAmount) }} USD</td>
                          <td>${{ formatMoney(inv.dDestAmount) }} MXN</td>
                          <td>${{ formatMoney(exchangeRateToday) }} MXN</td>
                        </tr>
                        <tr>
                          <td colspan="2" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountUsd) }} USD</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountMxn) }} MXN</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn color="black" elevation="8" class="mr-2 px-10" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined :disabled="loadingCollect" @click="collectStep = 1">
                    {{ 'Atrás' }}
                  </v-btn>
                  <v-btn color="black" elevation="8" class="white--text px-10" style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;" :disabled="loadingCollect || loadingCalculator" :loading="loadingCollect" @click="collectInvoices()">
                    {{ 'Confirmar cobro' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import moment from "moment";

  export default {
    name: "FacturasMX",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        isLoading: false,
        loading: false,
        busqueda: '',
        invoicesRaw: [],
        invoice: {},
        totalProfit: 0,
        clientRecipients: [],
        selectedClient: null,
        selectedStatus: "8e99628b-317c-4569-b149-9dc0105503a5",
        statusList: [
          { sName: "To pay", sStatusId: "8e99628b-317c-4569-b149-9dc0105503a5" },
          { sName: "Paid", sStatusId: "9cb23e7a-ca9b-4530-a617-83a894553b60" },
        ],
        dialogCreateInvoice: false,
        dialogEditInvoice: false,
        dialogDelete: false,
        forms: {
          new: {
            dPurchaseDate: "",
            sClientRecipientId: "",
            sInvoice: "",
            sId: "",
            dTotalAmount: "",
            dRateProtection: "",
            iCreditPeriod: "",
          },
          delete: {
            sInvoiceMXId: "",
          }
        },
        rules: {
          required: (v) => !!v || "El campo es obligatorio",
        },
        // Collect flow
        selectedInvoices: [],
        dialogCollect: false,
        collectStep: 1,
        selectedCollectType: null,
        collectDetail: { invoices: [] },
        loadingCalculator: false,
        loadingCollect: false,
        exchangeRateToday: null,
        exchangeRateTodayReference: null,
        totalAmountUsd: 0,
        totalAmountMxn: 0,
        companyAccount: null,
      }
    },
    watch: {
      activeTab(val) {
        if (val === 'facturasMX') {
          this.getClientRecipients();
          this.getInvoices();
          this.getExchangeRate();
        }
      }
    },
    mounted() {
      if (this.activeTab === 'facturasMX') {
        this.getClientRecipients();
        this.getInvoices();
        this.getExchangeRate();
      }
    },
    computed: {
      filteredInvoices() {
        if (!this.busqueda) return this.invoicesRaw;
        const q = this.busqueda.toLowerCase();
        return this.invoicesRaw.filter((item) => {
          const client = item.sName || '-';
          const purchaseDate = item.dPurchaseDate ? this.formatDate(item.dPurchaseDate) : '-';
          const dueDate = item.dDueDate ? this.formatDate(item.dDueDate) : '-';
          const invoiceNumber = item.sInvoice || '-';
          const internalId = item.sId || '-';
          const totalUsd = `$ ${this.formatMoney(item.dTotalAmount)} USD`;
          const rateProtection = `$ ${this.formatMoney(item.dRateProtection)} MXN`;
          return (
            client.toLowerCase().includes(q) ||
            purchaseDate.toLowerCase().includes(q) ||
            dueDate.toLowerCase().includes(q) ||
            invoiceNumber.toLowerCase().includes(q) ||
            internalId.toLowerCase().includes(q) ||
            totalUsd.toLowerCase().includes(q) ||
            rateProtection.toLowerCase().includes(q)
          );
        });
      },
    },
    methods: {
      toggleSelectInvoice(item) {
        if (this.isInvoiceSelected(item)) {
          this.selectedInvoices = this.selectedInvoices.filter(i => i.sInvoiceMXId !== item.sInvoiceMXId);
        } else {
          if (this.selectedInvoices.length >= 20) {
            this.mixWarning("Solo puedes seleccionar hasta 20 facturas.");
            return;
          }
          this.selectedInvoices.push(item);
        }
      },
      isInvoiceSelected(item) {
        return this.selectedInvoices.some(i => i.sInvoiceMXId === item.sInvoiceMXId);
      },

      getExchangeRate() {
        const payload = {
          currency: 'USD',
          desCurrency: 'MXN',
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };
        DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        })
        .then((response) => {
          this.exchangeRateToday = response.data.exchangeRateToday;
          this.exchangeRateTodayReference = response.data.exchangeRateTodayReference;
        })
        .catch((error) => {
          console.error('Error fetching exchange rate:', error);
        });
      },

      openCollectDialog() {
        this.dialogCollect = true;
        this.collectStep = 1;
        this.selectedCollectType = null;
        this.getExchangeRate();
        this.getCompanyAccount();
      },
      getCompanyAccount() {
        DB.post(`${URI}/api/v1/en/administrator/companyAccount`, {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        }, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        })
        .then((response) => {
          this.companyAccount = response.data.companyAccount;
        })
        .catch((error) => {
          console.error('Error fetching company account:', error);
        });
      },
      async openCollectDetail() {
        this.collectStep = 2;
        this.loadingCalculator = true;
        this.collectDetail.invoices = [];
        this.totalAmountUsd = 0;
        this.totalAmountMxn = 0;

        try {
          for (const inv of this.selectedInvoices) {
            const destAmount = await this.calculatorAmountInvoice(inv.dTotalAmount, this.exchangeRateTodayReference);
            this.collectDetail.invoices.push({
              sInvoiceMXId: inv.sInvoiceMXId,
              sInvoice: inv.sInvoice,
              sName: inv.sName,
              sClientRecipientId: inv.sClientRecipientId,
              dOriginAmount: parseFloat(inv.dTotalAmount),
              dDestAmount: parseFloat(destAmount),
              dExchangeRate: this.exchangeRateToday,
              sExchangeRateReference: this.exchangeRateTodayReference,
            });
            this.totalAmountUsd += parseFloat(inv.dTotalAmount);
            this.totalAmountMxn += parseFloat(destAmount);
          }
        } catch (error) {
          this.mixError("Error al calcular montos", 500);
        }
        this.loadingCalculator = false;
      },
      async calculatorAmountInvoice(amount, rate) {
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          amount: amount,
          rate: rate,
          reverse: false,
        };
        const response = await DB.post(`${URI}/api/v1/en/administrator/calculatorAmount`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        });
        return response.data.data.result;
      },
      collectInvoices() {
        this.loadingCollect = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          invoices: this.collectDetail.invoices,
          originCurrency: 'USD',
          destCurrency: 'MXN',
          collectType: this.selectedCollectType,
        };

        DB.post(`${URI}/api/v1/en/administrator/collectInvoicesMX`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        })
        .then((response) => {
          this.loadingCollect = false;
          this.cancelCollect();
          this.getInvoices();
          this.mixSuccess("Cobro realizado exitosamente.");
        })
        .catch((error) => {
          this.loadingCollect = false;
          this.mixError(
            error?.response?.data?.message || "Error al cobrar facturas",
            error?.response?.status || 500
          );
        });
      },
      cancelCollect() {
        this.dialogCollect = false;
        this.collectStep = 1;
        this.selectedCollectType = null;
        this.collectDetail = { invoices: [] };
        this.selectedInvoices = [];
        this.totalAmountUsd = 0;
        this.totalAmountMxn = 0;
      },

      getInvoices() {
        this.isLoading = true;
        this.invoicesRaw = [];
        this.totalProfit = 0;
        this.selectedInvoices = [];

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sClientRecipientId: this.selectedClient,
          sStatusId: this.selectedStatus,
        };

        DB.post(`${URI}/api/v1/en/administrator/client/invoicesMX`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          },
        })
          .then((response) => {
            this.invoicesRaw = response.data.invoices;
            this.invoicesRaw.forEach((invoice) => {
              this.totalProfit += parseFloat(invoice.dCurrencyGain || 0);
            });
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response && error.response.data && error.response.data.code) {
              this.$router.push("/welcome").catch(() => {});
            }
            this.mixError(
              error?.response?.data?.message || "Error al obtener facturas",
              error?.response?.status || 500
            );
          });
      },
      getClientRecipients() {
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };
        DB.post(`${URI}/api/v1/en/administrator/clientRecipients`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          },
        })
          .then((response) => {
            this.clientRecipients = response.data.clientRecipients;
          })
          .catch((error) => {
            this.mixError(
              error?.response?.data?.message || "Error al obtener clientes",
              error?.response?.status || 500
            );
          });
      },
      createInvoice() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;
          const payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            dPurchaseDate: this.forms.new.dPurchaseDate,
            sClientRecipientId: this.forms.new.sClientRecipientId,
            sInvoice: this.forms.new.sInvoice,
            sId: this.forms.new.sId,
            dTotalAmount: this.forms.new.dTotalAmount,
            dRateProtection: this.forms.new.dRateProtection,
            iCreditPeriod: this.forms.new.iCreditPeriod,
          };
          DB.post(`${URI}/api/v1/en/administrator/createInvoiceMX`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
            },
          })
            .then((response) => {
              this.loading = false;
              this.dialogCreateInvoice = false;
              this.resetNewForm();
              this.getInvoices();
              this.mixSuccess("Factura creada exitosamente.");
            })
            .catch((error) => {
              this.loading = false;
              this.mixError(
                error?.response?.data?.message || "Error al crear factura",
                error?.response?.status || 500
              );
            });
        }
      },
      updateInvoice() {
        if (this.$refs.formEdit.validate()) {
          this.loading = true;
          const payload = {
            sInvoiceMXId: this.invoice.sInvoiceMXId,
            dPurchaseDate: this.invoice.dPurchaseDate,
            sClientRecipientId: this.invoice.sClientRecipientId,
            sInvoice: this.invoice.sInvoice,
            sId: this.invoice.sId,
            dTotalAmount: this.invoice.dTotalAmount,
            dRateProtection: this.invoice.dRateProtection,
            iCreditPeriod: this.invoice.iCreditPeriod,
          };
          DB.put(`${URI}/api/v1/en/administrator/updateInvoiceMX`, payload, {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
            },
          })
            .then((response) => {
              this.loading = false;
              this.invoice = {};
              this.dialogEditInvoice = false;
              this.getInvoices();
              this.mixSuccess("Factura actualizada exitosamente.");
            })
            .catch((error) => {
              this.loading = false;
              this.mixError(
                error?.response?.data?.message || "Error al actualizar factura",
                error?.response?.status || 500
              );
            });
        }
      },
      openDialogDeleteInvoice(item) {
        this.dialogDelete = true;
        this.forms.delete.sInvoiceMXId = item.sInvoiceMXId;
      },
      deleteInvoice() {
        this.loading = true;
        const payload = {
          sInvoiceMXId: this.forms.delete.sInvoiceMXId,
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };
        DB.put(`${URI}/api/v1/en/administrator/deleteInvoiceMX`, payload, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
          },
        })
          .then((response) => {
            this.loading = false;
            this.dialogDelete = false;
            this.getInvoices();
            this.mixSuccess("Factura eliminada exitosamente.");
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(
              error?.response?.data?.message || "Error al eliminar factura",
              error?.response?.status || 500
            );
          });
      },
      resetNewForm() {
        this.forms.new = {
          dPurchaseDate: "",
          sClientRecipientId: "",
          sInvoice: "",
          sId: "",
          dTotalAmount: "",
          dRateProtection: "",
          iCreditPeriod: "",
        };
      },
      dataXLSX() {
        try {
          const data = this.invoicesRaw.map((item) => ({
            "Cliente": item.sName || "-",
            "Fecha de compra": item.dPurchaseDate ? this.formatDate(item.dPurchaseDate) : "-",
            "Fecha de vencimiento": item.dDueDate ? this.formatDate(item.dDueDate) : "-",
            "Factura": item.sInvoice || "-",
            "Orden de compra": item.sId || "-",
            "Monto total (USD)": this.formatMoney(item.dTotalAmount),
            "Tipo de cambio protegido": this.formatMoney(item.dRateProtection),
            "Currency gain": item.dCurrencyGain ? this.formatMoney(item.dCurrencyGain) : "-",
            "Profit (%)": item.dProfitPercentage ? this.formatMoney(item.dProfitPercentage) + "%" : "-",
          }));
          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Facturas PC");
          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          saveAs(blob, "Facturas_Por_Cobrar.xlsx");
        } catch (error) {
          console.log(error);
          this.mixError("Error al generar el archivo XLSX", 500);
        }
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate(date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY");
        return formattedDate;
      },
    },
  };
</script>

<style scoped>
.selected-card {
  border: 2px solid black !important;
}
</style>
